import { ScaleElement } from '@scale/base-element';
import { Events } from '@scale/events';

class ProductStockIndicator extends ScaleElement {
  setup() {
    this.onDocument(Events.VARIANT_SELECTED, (e) => {
      if (!e.variant) return;
      this.#update(e.variant);
    });
  }

  #update(variant) {
    if (!variant.available) {
      this.hidden = true;
      return;
    }
    this.hidden = false;

    const isManual = this.closest('[data-stock-indicator]')?.dataset.stockSource === 'manual';
    if (isManual) return;

    const threshold = this.getNumber('data-threshold', 10);
    const stock = variant.inventory_quantity ?? threshold + 1;
    const noTracking = !variant.inventory_management || variant.inventory_policy === 'continue';
    const effectiveStock = noTracking ? threshold + 1 : stock;
    const isLow = effectiveStock <= threshold && effectiveStock > 0;
    const pct = Math.min(100, (effectiveStock / threshold) * 100);

    this.classList.toggle('product-stock--low', isLow);

    const text = this.ref('text');
    if (text && isLow) {
      const count = Object.assign(document.createElement('b'), { className: 'product-stock__count', textContent: effectiveStock });
      const [before, after] = Scale.translations.stockLow.split('__count__');
      text.replaceChildren(before, count, after);
    } else if (text) {
      text.textContent = Scale.translations.stockInStock;
    }

    const fill = this.querySelector('.product-stock__fill');
    if (fill) fill.style.width = `${pct}%`;
  }
}

if (!customElements.get('product-stock-indicator')) {
  customElements.define('product-stock-indicator', ProductStockIndicator);
}
